import { IClip } from '../../../api/Data'

/**
 * Polling only needs to replace clips whose encoding state may have changed.
 * Reusing settled clip objects also preserves their signed media URLs, so
 * completed video cards do not reload whenever another clip is processing.
 */
export const mergePolledClips = (previousClips: IClip[], fetchedClips: IClip[]): IClip[] => {
  const previousById = new Map(previousClips.map((clip) => [clip.id, clip]))

  return fetchedClips.map((fetchedClip) => {
    const previousClip = previousById.get(fetchedClip.id)
    if (!previousClip) return fetchedClip

    const wasEncoding = previousClip.encodingStatus === 'encoding'
    const isEncoding = fetchedClip.encodingStatus === 'encoding'

    return wasEncoding || isEncoding ? fetchedClip : previousClip
  })
}
